import "./Teams.module.css";
import Header from "@/reusable_sections/Header";
import GlobalPortfolioShowcase from "./sections/GlobalPortfolioShowcase";
import RejoignezLAventure from "@/reusable_sections/Footer";
import { UnderConstruction } from "@/pages/UnderConstruction/UnderConstruction";
export default function TeamsPage() {
  return (
    // <div>
    //   <Header />
    //   <GlobalPortfolioShowcase />
    //   <RejoignezLAventure />
    // </div>

    <div className="container mx-auto py-12">
      <UnderConstruction />
    </div>
  );
}